import { useLocation } from 'react-router-dom';

export const useQueryParam = (key: string) => new URLSearchParams(useLocation().search).get(key);
